import '../../i18n/autoTranslate';
import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ 
  categories, 
  activeCategory, 
  onCategoryChange,
  className = "" 
}) => {
  const getCategoryIcon = (category) => {
    switch (category?.toLowerCase()) {
      case 'question banks':
        return 'MessageSquare';
      case 'answer templates':
        return 'FileText';
      case 'industry guides':
        return 'Building';
      case 'skill exercises':
        return 'Dumbbell';
      case 'video tutorials':
        return 'Play';
      case 'audio practice':
        return 'Headphones';
      case 'all':
        return 'Grid3X3';
      default:
        return 'BookOpen';
    }
  };

  return (
    <div className={`flex items-center space-x-2 overflow-x-auto scrollbar-hide ${className}`}>
      {categories?.map((category) => (
        <button
          key={category?.id}
          onClick={() => onCategoryChange(category)}
          className={`
            flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium
            whitespace-nowrap transition-all duration-200 ease-smooth
            ${activeCategory?.id === category?.id
              ? 'bg-white/10 text-white border border-white/15'
              : 'bg-white/5 text-white/70 hover:text-white hover:bg-white/10 border border-white/10'
            }
          `}
        >
          <Icon 
            name={getCategoryIcon(category?.name)} 
            size={16} 
            className={activeCategory?.id === category?.id ? 'text-white' : 'text-white/70'} 
          />
          <span>{category?.name}</span>
          {category?.count && (
            <span className={`
              px-1.5 py-0.5 text-xs rounded-full
              ${activeCategory?.id === category?.id
                ? 'bg-white/10 text-white' :'bg-white/10 text-white/60'
              }
            `}>
              {category?.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
